import Employee from './Employee'
import SalesOfficeApprover from './SalesOfficeApprover'
export class SaveSalesOfficeApproverRequest {
    SalesOfficeApprover: SalesOfficeApprover;
    SavedByEmployee: Employee;
}

export default SaveSalesOfficeApproverRequest;
